import { render, staticRenderFns } from "./demo_user.vue?vue&type=template&id=5c062476&scoped=true&"
import script from "./demo_user.vue?vue&type=script&lang=js&"
export * from "./demo_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c062476",
  null
  
)

export default component.exports